import { Materialized } from "@silversea-ssc/functional-support"
import * as E from "fp-ts/Either"
import { Either } from "fp-ts/Either"

export const Guards = {
    is:
        <A>(m: Materialized<unknown, A>) =>
        <L>(x: L | A): Either<L, A> =>
            m.strictType.is(x) ? E.right(x) : E.left(x),
}
